(($, Drupal) => {
  $(
    setTimeout(function() {
      //Fancybox logic
      //Adding Image fancy box logic
      var imageFancyBoxes = $(".hasImageFancybox");
      if (imageFancyBoxes.length) {
        imageFancyBoxes.each(function() {
          var imageFancyBoxComponent = $(this);
          var imageFancyBox = imageFancyBoxComponent.find(".fancyboxImage");
          imageFancyBox.attr("href", imageFancyBox.find("img").attr("src"));
          imageFancyBox.fancybox();
          activateFancybox();
        });
      }
      //Adding custom content fancy box logic like embed videos
      var fancyBoxes = $(".hasFancybox");
      if (fancyBoxes.length) {
        fancyBoxes.each(function() {
          var fancyBoxComponent = $(this);
          // var fancyBoxContent = fancyBoxComponent.find('.fancyboxContent');
          var fancyBoxLink = fancyBoxComponent.find(".fancyBoxTrigger");

          fancyBoxLink.fancybox();
          activateFancybox();
          console.log("Iframe fancybox initialized");
        });
      }

      //Adding Video Fancy Box with custom class: isVideoModal
      var videoFancyBoxes = $(".isVideoModal");
      if (videoFancyBoxes.length) {
        videoFancyBoxes.each(function() {
          var videoFancyBoxComponent = $(this);
          videoFancyBoxComponent.attr("data-fancybox", "true");
          activateFancybox();
          console.log(videoFancyBoxComponent);
          console.log("Video fancybox set up for initialization");
        });
      }

      //Activating Fancybox for any element that has the data attribute: data-fancybox
      function activateFancybox() {
        $("[data-fancybox]").fancybox({
          idleTime: false,
          media: {
            vimeo: {
              params: {
                autoplay: 1
              }
            },
            youtube: {
              params: {
                autoplay: 1
              }
            }
          }
        });
      }
    }),
    1
  );
})(jQuery, Drupal);
